import React from 'react';
import cx from 'classnames';

import { formatPrice } from 'utilities/money';

import { SubscriptionPlan } from '@payments/types';
import * as utils from '@payments/utils';

import style from './style.module.scss';

interface Props {
  defaultCoupon?: {
    couponCode: string;
    discountAmount: number;
  };
  isInstallments: boolean;
  pricingComponents: {
    name: string;
    priceInCents: number;
  }[];
  subscriptionPlan: SubscriptionPlan;
}

const SingleConfirmationFormGroup: React.FC<Props> = (props) => {
  const totalPrice = props.pricingComponents.reduce((sum, pricingComponent) => sum + pricingComponent.priceInCents, 0);

  const savingsPricingComponents = props.pricingComponents.filter((pricingComponent) => pricingComponent.priceInCents < 0);
  const savingsTotalPrice = savingsPricingComponents.reduce((sum, pricingComponent) => sum + pricingComponent.priceInCents, 0);

  return (
    <div>
      <div className="u-margin-B-m">
        <h4 className="u-margin-V-n inline-form-right">
          <strong>{props.subscriptionPlan.name}</strong>
        </h4>
        <p className="inline-form-right-help extra-bottom-margin">
          <small className="text-gray-light">
            Expires on {utils.calculateExpirationDate(props.subscriptionPlan.durationDays, props.subscriptionPlan.durationMonths)}
          </small>
        </p>
      </div>

      <table className={style.pricingComponentsTable}>
        <tbody>
          {
            props.pricingComponents.map((pricingComponent, idx) => (
              <>
                <tr key={idx}>
                  <td className={style.pricingComponentNameColumn}>
                    {pricingComponent.name}
                  </td>
                  <td className={style.pricingComponentPriceColumn}>
                    {formatPrice(pricingComponent.priceInCents)}
                  </td>

                  {
                    idx === 0 && props.defaultCoupon && (
                      <td className="hidden-xs text-gray-light u-padding-L-xs" style={{ fontSize: 12, textAlign: 'right' }}>
                        <s>{formatPrice(pricingComponent.priceInCents + props.defaultCoupon.discountAmount)}</s> with "{props.defaultCoupon.couponCode}"
                      </td>
                    )
                  }
                </tr>

                {
                  idx === 0 && props.defaultCoupon && (
                    <tr className="visible-xs">
                      <td className="text-gray-light u-padding-L-xs" colSpan={2} style={{ fontSize: 12, textAlign: 'right' }}>
                        <s>{formatPrice(pricingComponent.priceInCents + props.defaultCoupon.discountAmount)}</s> with "{props.defaultCoupon.couponCode}"
                      </td>
                    </tr>
                  )
                }
              </>
            ))
          }

          <tr>
            <td><hr className="u-margin-V-s" /></td>
            <td><hr className="u-margin-V-s" /></td>
          </tr>

          <tr>
            <td className={cx(style.pricingComponentNameColumn)} style={{ fontSize: props.isInstallments ? 16 : 20 }}>
              <strong>Total</strong>
            </td>
            <td className={cx(style.pricingComponentPriceColumn)} style={{ fontSize: props.isInstallments ? 16 : 20 }}>
              <strong>{formatPrice(totalPrice)}</strong>
            </td>
          </tr>

          {
            savingsTotalPrice < 0 && (
              <tr>
                <td className={cx(style.pricingComponentNameColumn, 'text-primary')}>
                  <strong>Total Savings</strong>
                </td>
                <td className={cx(style.pricingComponentPriceColumn, 'text-primary')}>
                  <strong>{formatPrice(savingsTotalPrice)}</strong>
                </td>
              </tr>
            )
          }

          {
            props.isInstallments && (
              <>
                <tr>
                  <td><hr className="u-margin-V-s" /></td>
                  <td><hr className="u-margin-V-s" /></td>
                </tr>

                <tr>
                  <td className={cx(style.pricingComponentNameColumn)} style={{ fontSize: 20 }}>
                    <strong>Total Today</strong>
                  </td>
                  <td className={cx(style.pricingComponentPriceColumn)} style={{ fontSize: 20 }}>
                    <strong>{formatPrice(utils.calculateInstallmentsPrice(totalPrice))}</strong>
                  </td>
                </tr>
              </>
            )
          }
        </tbody>
      </table>

      {
        props.isInstallments && (
          <div className="text-gray-light">
            And then 3 more payments of {formatPrice(utils.calculateInstallmentsPrice(totalPrice))} each
          </div>
        )
      }
    </div>
  );
};

export default SingleConfirmationFormGroup;
